// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundaryFallback_wrapper__eP6j_","wrapper-inner":"ErrorBoundaryFallback_wrapper-inner__WvbOE","error-content":"ErrorBoundaryFallback_error-content__65TZy"};